import { RouteConfig } from 'vue-router'

const Plans = () => import('../views/process-evaluation/Plans.vue')
const Form = () => import('../views/process-evaluation/Form.vue')
const Update = () => import('../views/process-evaluation/Update.vue')
const List = () => import('../views/process-evaluation/List.vue')
const Modes = () => import('../views/process-evaluation/Modes.vue')
const SourceList = () => import('../views/process-evaluation/SourceList.vue')
const Semesters = () => import('../views/process-evaluation/Semesters.vue')

export const plansRoute: RouteConfig = {
  path: '/process-evaluation-plans',
  name: '/process_evaluation_plans',
  component: Plans,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '设置',
  },
}

export const formRoute: RouteConfig = {
  path: '/process-evaluation-form',
  name: '/process_evaluation_form',
  component: Form,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '设置',
  },
}

export const updateRoute: RouteConfig = {
  path: '/process-evaluation-update',
  name: '/process_evaluation_update',
  component: Update,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '设置',
  },
}

export const listRoute: RouteConfig = {
  path: '/process-evaluation-list',
  name: '/process_evaluation_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '设置',
  },
}

export const modesRoute: RouteConfig = {
  path: '/process-evaluation-modes',
  name: '/process_evaluation_modes',
  component: Modes,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体育成绩评价',
  },
}

export const sourceListRoute: RouteConfig = {
  path: '/process-evaluation-source-list',
  name: '/process_evaluation_source_list',
  component: SourceList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '设置',
  },
}

export const semestersRoute: RouteConfig = {
  path: '/process-evaluation-semesters',
  name: '/process_evaluation_semesters',
  component: Semesters,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '设置',
  },
}

export default [plansRoute, formRoute, listRoute, modesRoute, updateRoute, sourceListRoute, semestersRoute]
